import { useHealthCheck } from "@/api/health";

/**
 * Página de estado del sistema. Consulta el health check real del backend
 * (GET /api/health) — no hay datos simulados: si el backend está caído,
 * esta pantalla lo refleja honestamente en vez de mostrar contenido falso.
 */
export default function SystemStatusPage() {
  const { data, isLoading, isError, error } = useHealthCheck();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="card max-w-lg w-full p-8">
        <h1 className="text-xl font-semibold text-gray-900">ERP Firma Profesional</h1>
        <p className="mt-1 text-sm text-gray-500">Estado del sistema (backend + infraestructura)</p>

        {isLoading && <p className="mt-6 text-sm text-gray-500">Consultando estado del backend...</p>}

        {isError && (
          <div className="mt-6 rounded-md bg-red-50 border border-red-200 p-4">
            <p className="text-sm font-medium text-red-800">No se pudo conectar con el backend</p>
            <p className="mt-1 text-xs text-red-600">{(error as Error)?.message}</p>
            <p className="mt-2 text-xs text-gray-500">
              Verifique que el servicio backend esté corriendo (docker compose up) en {import.meta.env.VITE_API_URL}.
            </p>
          </div>
        )}

        {data && (
          <div className="mt-6 space-y-3">
            <div
              className={`rounded-md p-3 text-sm font-medium ${
                data.status === "healthy" ? "bg-green-50 text-green-800" : "bg-yellow-50 text-yellow-800"
              }`}
            >
              Estado general: {data.status === "healthy" ? "Saludable ✅" : "Degradado ⚠️"}
            </div>
            <dl className="divide-y divide-gray-100 text-sm">
              {Object.entries(data.checks).map(([key, value]) => (
                <div key={key} className="flex justify-between py-2">
                  <dt className="text-gray-500 capitalize">{key}</dt>
                  <dd className={value === "ok" ? "text-green-700" : "text-red-700"}>{value}</dd>
                </div>
              ))}
              <div className="flex justify-between py-2">
                <dt className="text-gray-500">Uptime</dt>
                <dd className="text-gray-900">{Math.floor(data.uptimeSeconds)}s</dd>
              </div>
            </dl>
          </div>
        )}

        <div className="mt-8 border-t border-gray-100 pt-4 text-xs text-gray-400">
          Fase 1 (Arquitectura) completada. El login y el dashboard se habilitan en las siguientes fases.
        </div>
      </div>
    </div>
  );
}
